<template>
  <div class="foot-box">
    <div class="foot">
      <div class="area-box">
        <div class="logo-box">
          <div class="title">联系方式</div>
          <div class="more-text">冯老师：870111689@qq.com</div>
          <div class="more-text">王老师：wd877346426@qq.com</div>
          <div class="more-text">电话：010-84083678</div>
          <div class="more-text">地址：北京市西城区鼓楼西大街甲158号</div>
        </div>
      </div>
      <div class="area-box">
        <div class="other-link">
          <div class="box-item" v-for="menu of menuList">
            <div class="title">{{ menu.title }}</div>
            <div class="menu-list">
              <div class="menu-item" v-for="item of menu.list" @click="chooseMenu(menu.type, item)">{{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="area-box">
        <div class="contact-us">
          <div class="title">数字社科</div>
          <img class="person-qrcode" src="@/assets/images/qrcode/1.jpg" alt />
        </div>
        <div class="contact-us">
          <div class="title">点读历史</div>
          <img class="person-qrcode" src="@/assets/images/qrcode/2.jpg" alt />
        </div>
      </div>
    </div>

    <Copyright></Copyright>

    <div class="popup-box" v-if="qrcode">
      <div class="blackscreen" @click="qrcode = ''"></div>
      <div class="box-content">
        <img :src="qrcode" />
      </div>
    </div>
  </div>
</template>
<script>

import Copyright from '@/component/public/Copyright';

export default {
  name: 'foot',
  components: {
    Copyright
  },
  data() {
    return {
      menuList: [
        {
          title: '友情链接',
          type: 'link',
          list: [
            { name: '中国社会科学出版社', url: 'http://www.csspw.cn/' },
            { name: '中国社会科学文库', url: 'https://www.sklib.cn/' },
            { name: '中国近代影像资料库', url: 'https://www.lzp360.com/' },
            { name: '中国社会科学年鉴数据库', url: 'https://www.eyearbook.cn/' },
            { name: '中国社会科学网', url: 'https://www.cssn.cn/' },
            { name: '中国学研究数据库', url: 'https://wacs.sklib.cn/' }
          ]
        }
      ],

      qrcode: ''
    }
  },
  mounted() {
    //监听store
    // this.$store.subscribe((res) => {
    //   if (!res) return;

    //   let { type, payload } = res;
    // })
  },
  methods: {
    //选择菜单
    chooseMenu(type, item) {
      if (type == 'link') window.open(item.url);
      else this.qrcode = require(`@/assets/images/home/qrcode/${item.name}.jpg`);
    },
    //打开出版物经营许可证
    openCode(url) {
      this.qrcode = url;
    },
    //打开链接
    openUrl(url) {
      window.open(url);
    }
  }
}
</script>
<style scoped lang="scss">
@import "./foot.scss";
</style>